import React from "react";
import { config } from "../utils/config";

const PrivateFooter = () => {
  return (
    <footer style={{
      padding: "10px 20px",
      textAlign: "center",
      fontSize: "12px",
      color: "#666",
      position: "fixed",
      bottom: "0",
      left: "200px",
      right: "0",
      backgroundColor: "#fff",
      // zIndex: "1000"
    }}>
      <p>Teedex Version: {config.APP_VERSION}</p>
    </footer>
  );
};

export default PrivateFooter;
